import { RouteProp, useRoute } from '@react-navigation/native';
import { theme } from 'aimo-ui';
import CrickleCutCardBackground from 'components/common/CrickleCutCardBackground';
import { usePoolingGroupData } from 'hooks/usePoolingGroupData';
import React from 'react';
import { ScrollView } from 'react-native';
import { RootStackParamList } from 'types/navigation';
import ModalContentWrapper from '../ModalContentWrapper';
import { PoolingGroupHeader } from './PoolingGroupHeader';
import { PoolingGroupInfo } from './PoolingGroupInfo';

const PoolingGroup: React.FC = () => {
  const {
    params: { permitId, poolingGroupUid },
  } = useRoute<RouteProp<RootStackParamList, 'poolingGroup'>>();

  const { poolingGroup } = usePoolingGroupData(permitId, poolingGroupUid);

  const aboveCutView = React.useCallback(
    () => <PoolingGroupHeader poolingGroup={poolingGroup} />,
    [poolingGroup]
  );

  const belowCutView = React.useCallback(
    () => <PoolingGroupInfo poolingGroup={poolingGroup} />,
    [poolingGroup]
  );

  return (
    <ScrollView>
      <ModalContentWrapper>
        <CrickleCutCardBackground
          cutColor={theme.colors.lightBg.lilac}
          aboveCutView={aboveCutView}
          belowCutView={belowCutView}
          backgroundColor={theme.colors.lightBg.lilac}
        />
      </ModalContentWrapper>
    </ScrollView>
  );
};

export default PoolingGroup;
